import { render } from "./ProjectInvoice.vue?vue&type=template&id=e6ec4426"
import script from "./ProjectInvoice.vue?vue&type=script&lang=js"
export * from "./ProjectInvoice.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__